import { render } from "./ClientesPage.vue?vue&type=template&id=2eb84256"
import script from "./ClientesPage.vue?vue&type=script&lang=js"
export * from "./ClientesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__